<!--
// app/components/pages/teams-team/HeroTeamPage.vue
-->
<script setup lang="ts">
import type { Team } from "~/src/team/domain/models/Team";
import type { SocialMediaNames } from "~/src/region/domain/models/Region";
import { setAliasUrl } from "~/src/Shared/utils";
import { useRegions } from "~/app/composables/regions";
import SocialIcons from "~/app/components/Shared/SocialIcons.vue";
import CardStoreAd from "~/app/components/Shared/CardStoreAd.vue";

type Props = {
  team: Team;
  teamSocialProfiles: { [key in SocialMediaNames]?: string | undefined };
  teamAdStoreImage?: string;
  teamAdStoreLink?: string;
  featuringWorldCup?: boolean;
};
const props = defineProps<Props>();
const { isSpain, isAmericas } = useRegions();
</script>

<template>
  <div
    v-if="team.metaInformation?.loop_video_url"
    class="absolute right-0 left-0 top-0 bottom-0 z-[1] flex justify-center items-center overflow-hidden"
  >
    <video
      :src="team.metaInformation.loop_video_url"
      autoplay
      loop
      muted
      playsinline
      :poster="team.metaInformation.loop_video_poster"
      class="min-h-full min-w-[250%] right-[50%] bigsm:min-w-full bigsm:right-0"
    ></video>
  </div>
  <nuxt-img
    v-else-if="team.metaInformation?.loop_video_poster"
    :src="setAliasUrl(team.metaInformation?.loop_video_poster) || ''"
    width="1440"
    height="542"
    sizes="375px sm:860px lg:1440px"
    fit="outside"
    class="absolute right-0 left-0 top-0 bottom-0 z-[1] w-full h-full object-cover object-center"
  ></nuxt-img>
  <div
    class="flex flex-col justify-center items-center h-full py-4 absolute top-0 right-0 left-0 bottom-0 z-[3]"
    style="background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%)"
  >
    <div class="container-logo-team-page mt-auto">
      <NuxtImg
        :src="setAliasUrl(team.logo.url) || ''"
        :alt="team.completeName || ''"
        class="object-contain w-full h-full"
        preload
        width="256"
        height="256"
      />
    </div>
    <h1 class="text-[26px] md:text-3xl font-bold font-['Archivo_Expanded']">
      {{ team.completeName }}
    </h1>
    <div class="mt-9 mb-auto">
      <social-icons :social-profiles="teamSocialProfiles"></social-icons>
    </div>
  </div>
  <div class="absolute top-4 right-4 z-[4] hidden sm:block">
    <card-store-ad
      light
      :product-title="$t('card.store.productTitle.shirtTeamAmericas', { teamName: team.completeName })"
      :title-card="$t('card.store.officialStore.title')"
      :product-image="teamAdStoreImage"
      :product-link="teamAdStoreLink"
      with-title
      small
      closable
    ></card-store-ad>
  </div>
</template>

<style scoped>
.container-logo-team-page {
  @apply w-40 h-40 md:h-64 md:w-64 p-3 flex justify-center items-center;
}
</style>
